import React, { memo, useMemo } from 'react'
import styled from 'styled-components'
import { Box, Text } from 'pcln-design-system'
import dayNameBuilder from '../utils/dayNameBuilder/dayNameBuilder'

const DayName = styled(Box)`
  display: inline-block;
  vertical-align: top;
  text-transform: capitalize;
  padding: 2px 0;
  text-align: center;
`

interface IDayNamesProps {
  locale?: string
}

function DayNames({ locale }: IDayNamesProps) {
  const memoizedDays = useMemo(() => dayNameBuilder({ format: 'abbreviated', locale }), [locale])

  return (
    <Box pt={2}>
      {memoizedDays.map((name, index) => (
        <DayName key={name} width={1 / 7} data-testid={`day-name-${index}`}>
          <Text fontSize={0} color='text.light'>
            {name}
          </Text>
        </DayName>
      ))}
    </Box>
  )
}

export default memo(DayNames)
